var React = require('react');

function Minus1 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 23.5c0-1.933 2.099-3.5 4.688-3.5h20.624C36.903 20 39 21.567 39 23.5S36.901 27 34.312 27H13.689C11.098 27 9 25.433 9 23.5z"}));
}

Minus1.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = Minus1;

Minus1.default = Minus1;
